import { useMemo } from "react";
import { Table } from "antd";

import dayjs from "dayjs";

import CellAddition from "@/components/inputs/CellAddition";
import EmployeeProfile from "@/components/cards/EmployeeProfile";

// Таблица учета времени сотрудников за месяц
// Содержит список сотрудников и время по дням
// Тут можно настроить колонки
const TimeTrackingTable = ({
  data,
  dayCount,
  firstDay,
  pagination,
  loading,
  onAddRecord,
  onChange,
  scroll = { x: "100%" },
}) => {
  const columns = useMemo(() => {
    const baseColumns = [
      {
        title: "№",
        dataIndex: "table_number",
        fixed: "left",
        width: 90,
        sorter: {
          compare: (a, b) => {
            const str1 = a.table_number;
            const str2 = b.table_number;

            return str1?.localeCompare(str2);
          },
          multiple: 2,
        },
      },
      {
        title: "ФИО",
        width: 300,
        fixed: "left",
        dataIndex: "name",
        defaultSortOrder: "ascend",
        sorter: {
          compare: (a, b) => {
            const nameA = `${a.lastname || ""} ${a.firstname || ""} ${
              a.patronymic || ""
            }`;
            const nameB = `${b.lastname || ""} ${b.firstname || ""} ${
              b.patronymic || ""
            }`;

            return nameA.localeCompare(nameB);
          },
          multiple: 1,
        },
        render: (_, record) => (
          <EmployeeProfile avatarSize={40} bold {...record} showPosition />
        ),
      },
      {
        title: "∑",
        dataIndex: "sum",
        width: 60,
        align: "center",
        className: `secondary-column`,
        render: (_, { work_records }) => {
          if (!work_records || !work_records[0]) return 0;

          const totalHours = work_records.reduce(
            (total, { worked_hours }) =>
              total + (parseFloat(worked_hours) || 0),
            0
          );

          return totalHours % 1 === 0 ? totalHours.toFixed(0) : totalHours;
        },
      },
    ];

    const dayColumns = Array.from({ length: dayCount }, (_, index) => {
      const day = index + 1;
      const currentDate = dayjs(firstDay).date(day);
      const isWeekend = currentDate.day() === 0 || currentDate.day() === 6;
      // 0 - воскресенье, 6 - суббота

      return {
        title: day.toString(),
        dataIndex: day.toString(),
        width: 60,
        align: "center",
        className: `no-padding ${isWeekend ? "weekend-column" : ""}`,
        render: (_, item) => {
          const { work_records } = item;

          let currentNote;
          let hours = 0;

          if (work_records) {
            currentNote = work_records.find((record) => {
              const recordDay = parseInt(record.work_date.split("-")[2], 10);
              return recordDay === day;
            });

            if (currentNote) {
              hours = parseFloat(currentNote.worked_hours);
            }
          }

          // console.log(day, currentNote, hours);

          return (
            <>
              {!!hours && <span>{hours}</span>}
              <CellAddition
                hours={hours}
                onClick={() =>
                  onAddRecord({
                    day,
                    hours,
                    record_uuid: currentNote && hours ? currentNote.uuid : "",
                    description: currentNote ? currentNote.description : "",
                    ...item,
                  })
                }
              />
            </>
          );
        },
      };
    });

    return [...baseColumns, ...dayColumns];
  }, [dayCount, onAddRecord, firstDay]);

  return (
    <Table
      dataSource={data}
      columns={columns}
      rowKey={(record) => record.uuid}
      loading={loading}
      pagination={pagination}
      onChange={onChange}
      showSorterTooltip={{
        target: "sorter-icon",
        title: "Нажмите для сортировки",
      }}
      scroll={scroll}
    />
  );
};

export default TimeTrackingTable;
